/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Browser_Extensions_CatInputs */

const en_svc_browser_extensions_cat = /** @type {(inputs: Svc_Browser_Extensions_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#EXT`)
};

const ar_svc_browser_extensions_cat = /** @type {(inputs: Svc_Browser_Extensions_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#إضافات`)
};

const bn_svc_browser_extensions_cat = /** @type {(inputs: Svc_Browser_Extensions_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#EXT`)
};

const de_svc_browser_extensions_cat = /** @type {(inputs: Svc_Browser_Extensions_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#EXT`)
};

const es_svc_browser_extensions_cat = /** @type {(inputs: Svc_Browser_Extensions_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#EXT`)
};

const fr_svc_browser_extensions_cat = /** @type {(inputs: Svc_Browser_Extensions_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#EXT`)
};

const pt_svc_browser_extensions_cat = /** @type {(inputs: Svc_Browser_Extensions_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#EXT`)
};

const zh_svc_browser_extensions_cat = /** @type {(inputs: Svc_Browser_Extensions_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#EXT`)
};

const tr_svc_browser_extensions_cat = /** @type {(inputs: Svc_Browser_Extensions_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#EXT`)
};

const ru_svc_browser_extensions_cat = /** @type {(inputs: Svc_Browser_Extensions_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#EXT`)
};

const pl_svc_browser_extensions_cat = /** @type {(inputs: Svc_Browser_Extensions_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#EXT`)
};

/**
* | output |
* | --- |
* | "#EXT" |
*
* @param {Svc_Browser_Extensions_CatInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_browser_extensions_cat = /** @type {((inputs?: Svc_Browser_Extensions_CatInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Browser_Extensions_CatInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_browser_extensions_cat(inputs)
	if (locale === "bn") return bn_svc_browser_extensions_cat(inputs)
	if (locale === "de") return de_svc_browser_extensions_cat(inputs)
	if (locale === "es") return es_svc_browser_extensions_cat(inputs)
	if (locale === "fr") return fr_svc_browser_extensions_cat(inputs)
	if (locale === "pt") return pt_svc_browser_extensions_cat(inputs)
	if (locale === "zh") return zh_svc_browser_extensions_cat(inputs)
	if (locale === "tr") return tr_svc_browser_extensions_cat(inputs)
	if (locale === "ru") return ru_svc_browser_extensions_cat(inputs)
	if (locale === "pl") return pl_svc_browser_extensions_cat(inputs)
	return en_svc_browser_extensions_cat(inputs)
});
export { svc_browser_extensions_cat as "svc_browser-extensions_cat" }